export type TEventCommand = 'config' | 'event';

declare global {
  interface Window {
    gtag: (
      command: TEventCommand,
      eventId?: string,
      params?: Record<string, any>
    ) => void;
  }
}

const DEBUG_EVENTS = localStorage.getItem('debugGAEvents');

/**
 * @description This function sends a Google Analytics events.
 * @param eventAction - The action name for the event.
 * @param eventParams - The parameters for the event.
 */
export const sendGAEvent = <EventParams extends Record<string, any>>(
  eventAction: string,
  eventParams: EventParams
) => {
  if (DEBUG_EVENTS === 'true' || DEBUG_EVENTS === eventParams?.event_category) {
    console.log({ eventAction, eventParams });
  }

  if (!window.gtag) return;
  window.gtag('event', eventAction, eventParams);
};

/**
 * @param config - The configuration object for Google Analytics.
 * @description This function sets the Google Analytics configuration.
 */
export const setGAConfig = <GAConfig extends Record<string, any>>(
  config: GAConfig
) => {
  if (DEBUG_EVENTS === 'true') {
    console.log('[GA Config]', config);
  }

  if (!window.gtag) return;
  window.gtag('config', window.appConfig.GA_MEASUREMENT_ID, config);
};
